import type { OrganizationType, Subject } from "./types";

const routeRoles: Record<OrganizationType, Record<string, readonly string[]>> = {
  platform: {
    "/dashboard": ["platform_owner", "platform_finance", "platform_technical"],
    "/market": ["platform_owner"],
    "/orders": ["platform_owner", "platform_finance", "platform_technical"],
    "/automation": ["platform_owner"],
    "/integrations": ["platform_owner", "platform_technical"],
    "/reports": ["platform_owner", "platform_finance", "platform_technical"],
    "/supply-demand": ["platform_owner", "platform_finance", "platform_technical"],
    "/finance": ["platform_owner", "platform_finance"],
    "/finance/topups": ["platform_owner", "platform_finance"],
    "/finance/activity": ["platform_owner", "platform_finance"],
    "/finance/refunds": ["platform_owner", "platform_finance"],
    "/finance/invoices": ["platform_owner", "platform_finance"],
    "/credit": ["platform_owner", "platform_finance", "platform_technical"],
    "/support": ["platform_owner", "platform_finance", "platform_technical"],
    "/security": ["platform_owner", "platform_finance", "platform_technical"],
  },
  supplier: {
    "/dashboard": ["supplier_owner", "supplier_finance", "supplier_operator"],
    "/inventory": ["supplier_owner", "supplier_operator"],
    "/orders": ["supplier_owner", "supplier_finance", "supplier_operator"],
    "/developer": ["supplier_owner", "supplier_operator"],
    "/developer/imports": ["supplier_owner", "supplier_operator"],
    "/developer/clients": ["supplier_owner"],
    "/developer/webhooks": ["supplier_owner", "supplier_operator"],
    "/developer/webhook-deliveries": ["supplier_owner", "supplier_operator"],
    "/developer/proofs": ["supplier_owner", "supplier_operator"],
    "/reports": ["supplier_owner", "supplier_finance", "supplier_operator"],
    "/supply-demand": ["supplier_owner", "supplier_finance", "supplier_operator"],
    "/finance": ["supplier_owner", "supplier_finance"],
    "/finance/settlements": ["supplier_owner", "supplier_finance"],
    "/finance/withdrawals": ["supplier_owner", "supplier_finance"],
    "/finance/accounts": ["supplier_owner", "supplier_finance"],
    "/finance/activity": ["supplier_owner", "supplier_finance"],
    "/credit": ["supplier_owner", "supplier_finance", "supplier_operator"],
    "/support": ["supplier_owner", "supplier_finance", "supplier_operator"],
    "/security": ["supplier_owner", "supplier_finance", "supplier_operator"],
  },
  operator: {
    "/dashboard": ["admin", "manager", "operator"],
    "/operations": ["admin", "manager", "operator"],
    "/operations/platforms": ["admin", "manager", "operator"],
    "/operations/suppliers": ["admin", "manager", "operator"],
    "/operations/managed-platforms": ["admin", "manager", "operator"],
    "/operations/inventory": ["admin", "manager", "operator"],
    "/operations/targets": ["admin", "manager", "operator"],
    "/operations/hosted-newapi": ["admin", "manager", "operator"],
    "/operations/assignments": ["admin", "manager", "operator"],
    "/operations/deliveries": ["admin", "manager", "operator"],
    "/operations/reviews": ["admin", "manager"],
    "/operations/team": ["admin", "manager"],
    "/operations/audit": ["admin", "manager"],
    "/catalog-admin": ["admin", "manager"],
    "/finance": ["admin", "manager", "operator"],
    "/finance/balances": ["admin", "manager", "operator"],
    "/finance/adjustments": ["admin", "manager", "operator"],
    "/finance/refunds": ["admin", "manager"],
    "/finance/withdrawals": ["admin", "manager"],
    "/finance/commissions": ["admin", "manager", "operator"],
    "/finance/platform-revenue": ["admin", "manager"],
    "/finance/invoices": ["admin", "manager", "operator"],
    "/reports": ["admin", "manager", "operator"],
    "/supply-demand": ["admin", "manager", "operator"],
    "/system": ["admin"],
    "/system/users": ["admin"],
    "/system/organizations": ["admin"],
    "/system/operators": ["admin"],
    "/system/payments": ["admin"],
    "/system/mail": ["admin"],
    "/system/audit": ["admin"],
    "/system/health": ["admin"],
    "/support": ["admin", "manager", "operator"],
    "/security": ["admin", "manager", "operator"],
  },
};

export function hasAnyRole(subject: Subject | null | undefined, roles: readonly string[]) {
  return Boolean(subject?.roles.some((role) => roles.includes(role)));
}

export function canAccessPath(subject: Subject, path: string) {
  return hasAnyRole(subject, routeRoles[subject.organization_type][path] ?? []);
}
